<template>
  <component class="app" id="app" :is="layout">
    <router-view />
  </component>
</template>

<script>
import AuthLayout from "@/views/layouts/AuthLayout";
import AppLayout from "@/views/layouts/AppLayout";
import { CartApi } from "@/office/cart/cart-api";
import { UPDATE_CART_ITEMS_COUNT } from "@/store/action-types";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: { AuthLayout, AppLayout },
  metaInfo() {
    return {
      title: this.$t("notary_pay.page_title"),
      titleTemplate: "%s",
    };
  },
  computed: {
    layout() {
      return this.$route.meta.layout || "app-layout";
    },
    ...mapGetters(["userLoggedIn"]),
  },
  created() {
    if (this.userLoggedIn) {
      this.loadCart();
    }
  },
  watch: {
    userLoggedIn: function () {
      this.loadCart();
    },
  },
  methods: {
    loadCart() {
      new CartApi().loadCart().then((r) => {
        this.$store.dispatch(UPDATE_CART_ITEMS_COUNT, r.data.items_count);
      });
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/_base.scss";
</style>
